/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const showToast = function (msg) {
  $('.sor-toast').html(msg);
  $('#sor-toast').fadeIn(500).delay(2000).fadeOut(1000);
};

const initToastMessage = function () {
  try {
    const storage = window.sessionStorage;
    if (storage.getItem('sorToastMessage') !== null) {
      showToast(storage.getItem('sorToastMessage'));
      storage.removeItem('sorToastMessage');
    }
  } catch (error) {}
};

module.exports = {
  initToastMessage: initToastMessage
};
